import Icon from '@mui/icons-material/Logout'
import { grey } from '@mui/material/colors'
import { useMemo } from 'react'

export const LogoutIcon = (props) => {
    return useMemo(
        () => <Icon sx={{ color: grey[50], marginX: '10px' }} {...props} />,
        [props]
    )
}
